import Vue from 'vue';
import Vuex from 'vuex';
import taxonomyModule from '@/features/taxonomy/store';
import documentsModule from '@/features/documents/store';
import AppraiserModule from '@/features/appraiser/store';
import AjdModule from '@/features/ajd/store';
import proposalModule from '@/features/propuesta-no-vinculante/store';
import reportModule from '@/features/reports/store';

import AnalisisModule from '@/features/analisis/store';
import PropuestaModule from '@/features/tab-propuesta/store';
import OperationTabModule from '@/features/tab-operation/store';
import GarantiaModule from '@/features/tab-garantia/store';
import DatosEconomicosModule from '@/features/tab-datos-economicos/store';
import ClienteModule from '@/features/tab-cliente/store';
import NewOperationModule from '@/features/operation-new/store';
import OperationFeatureModule from '@/features/operation/store';
import menuOperacionesModule from '@/features/menu-operaciones/store';
import menuClienteModule from '@/features/menu-clientes/store';
import menuColaboradorModule from '@/features/menu-colaboradores/store';
import menuInversoresModule from '@/features/menu-inversores/store';
import JuridicoModule from '@/features/juridico/store';
import FinanceModule from '@/features/financiero/store';
import CesionesModule from '@/features/cesiones/store';
import NotaryModule from '@/features/notary/store';
import FormalizacionModule from '@/features/formalizacion/store';
import CancelacionModule from '@/features/cancelacion/store';
import CollaboratorFeatureModule from '@/features/colaborador/store';
import menuCesionesModule from '@/features/menu-cesiones/store';
import menuFichaComercialModule from '@/features/menu-ficha-comercial/store';
import menuFichaInmobiliariaModule from '@/features/menu-ficha-inmobiliaria/store';
import riesgosModule from '@/features/sancion-riesgos/store';

// models
import { UserModule } from '@/models/user';
import { OperationModule } from '@/models/operation';
import { ClientModule } from '@/models/client';
import { DatesAssignementsModule } from '@/models/datesAssigments';
import { EmployeeModule } from '@/models/employee';
import { CesionModule } from '@/models/cesion';
import { InversorModule } from '@/models/inversor';
import { TaxonomyLetraModule } from '@/models/taxonomyLetra';
import { TaxonomyDepartmentModule } from '@/models/taxonomyDepartment';
import { InstanciaLetraModule } from '@/models/instanciaLetra';
import { InstanciaLetraCesionModule } from '@/models/instanciaLetraCesion';
import { CollaboratorModule } from '@/models/colaborador';
import { ContactoModule } from '@/models/contacto';
import { ReputationModule } from '@/models/reputation';
import { DocumentModule } from '@/models/document';
import { DocumentTypeModule } from '@/models/DocumentType';
import { FileModule } from '@/models/file';
import { FileDocumentModule } from '@/models/fileDocument';
import { FileImageModule } from '@/models/fileImage';
import { ExpensesModule } from '@/models/expenses';
import { ProvisionModule } from '@/models/provision';
import { NexumImageModule } from '@/models/nexumImage';
import { NexumDocumentModule } from '@/models/nexumDocument';
import { BusinessCardModule } from '@/models/businessCard';
import { RealtyManagementModule } from '@/models/realtyManagement';
import { ReportModule } from '@/models/report';
import { PreReportModule } from '@/models/prereport';
import { PledgeModule } from '@/models/pledge';
import { NotarioModule } from '@/models/notary';
import { OwnerModule } from '@/models/owner';
import { state } from './state';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import plugins from './plugins';

Vue.use(Vuex);

let storeToExport = null;

if (module.hot) {
  storeToExport = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins,
    modules: {
      ajd: AjdModule,
      appraiser: AppraiserModule,
      taxonomy: taxonomyModule,
      documents: documentsModule,
      propuestano: proposalModule,
      riesgos: riesgosModule,
      menu_ficha_comercial: menuFichaComercialModule,
      menu_ficha_inmobiliaria: menuFichaInmobiliariaModule,
      report: reportModule,
      'propuesta-tab': PropuestaModule,
      'operation-tab': OperationTabModule,
      garantia: GarantiaModule,
      'datos-economicos': DatosEconomicosModule,
      cliente: ClienteModule,
      'operation-new': NewOperationModule,
      operation: OperationFeatureModule,
      menuoperaciones: menuOperacionesModule,
      menucliente: menuClienteModule,
      menuinversores: menuInversoresModule,
      juridico: JuridicoModule,
      financiero: FinanceModule,
      cesiones: CesionesModule,
      analisis: AnalisisModule,
      notary: NotaryModule,
      formalizacion: FormalizacionModule,
      cancelacion: CancelacionModule,
      collaborator: CollaboratorFeatureModule,
      menucesiones: menuCesionesModule,
      menucolaborador: menuColaboradorModule,
      // models
      user_model: UserModule,
      operation_model: OperationModule,
      client_model: ClientModule,
      contact_model: ContactoModule,
      reputation_model: ReputationModule,
      pledge_model: PledgeModule,
      datesAssignements_model: DatesAssignementsModule,
      employee_model: EmployeeModule,
      cesion_model: CesionModule,
      letra_tax_model: TaxonomyLetraModule,
      instanciaLetra_model: InstanciaLetraModule,
      instanciaLetraCesion_model: InstanciaLetraCesionModule,
      inversor_model: InversorModule,
      collaborator_model: CollaboratorModule,
      taxonomy_department: TaxonomyDepartmentModule,
      document_model: DocumentModule,
      documentType_model: DocumentTypeModule,
      file_model: FileModule,
      fileDocument_model: FileDocumentModule,
      fileImage_model: FileImageModule,
      provision_model: ProvisionModule,
      report_model: ReportModule,
      prereport_model: PreReportModule,
      expenses_model: ExpensesModule,
      nexumImage_model: NexumImageModule,
      nexumDocument_model: NexumDocumentModule,
      businessCard_model: BusinessCardModule,
      realtyManagement_model: RealtyManagementModule,
      notario_model: NotarioModule,
      owner_model: OwnerModule,
    },
  });
} else {
  storeToExport = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins,
    modules: {
      user_model: UserModule,
      employee_model: EmployeeModule,
      taxonomy_department: TaxonomyDepartmentModule,
      document_model: DocumentModule,
      documentType_model: DocumentTypeModule,
      file_model: FileModule,
      fileDocument_model: FileDocumentModule,
      fileImage_model: FileImageModule,
      nexumImage_model: NexumImageModule,
      nexumDocument_model: NexumDocumentModule,
    },
  });
}
const store = storeToExport;
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js